import { AWARD_LOGO_URL } from 'lib/awards/constants'

const data = {
  title: 'We’re the Low-Cost Funeral Provider of the Year',
  description:
    'Our award-winning team are here 7 days a week to support you through the process. We believe everyone deserves a send-off as unique as they are, without compromising on cost, or quality.',
  imagePath: 'e_trim/external-logos/good_funeral_awards_with_circle_bg',
  mobileImagePath: AWARD_LOGO_URL.GOOD_FUNERAL_AWARDS_NO_YEAR,
}

export default data
